import Link from '@components/atoms/Link';
import { visuallyHidden } from '@styles/utils';
import styled from 'styled-components';

export const SkipContainer = styled.div`
  background: ${({ theme }) => theme.colors.colorAcadia};
  padding: ${({ theme }) => theme.spacing.smallMedium};
  display: flex;
  justify-content: center;
  align-items: center;

  /* Hide container unless a link or button inside is focused */
  &:not(:has(:focus-within)) {
    ${visuallyHidden}
  }

  /* Only show the focused element */
  a:not(:focus) {
    ${visuallyHidden}
  }
`;

export const SkipLink = styled(Link)`
  color: ${({ theme }) => theme.colors.colorWhite};
  &:focus {
    outline: none;
  }
`;
